
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/machidukuri",
      function () {
        return require("private-next-pages/news/machidukuri/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/machidukuri"])
      });
    }
  